import React from "react";
import "./index.css";

/*
    This is a general component used to contain a headline and some content.
    You'll probably never need to edit this. If you do, any changes will affect
    all components that use this component, for example Stats and Events.
*/
const ContentBox = ({ header, children }) => {
  return (
    <div className="content-box">
      <div className="content-box-header">{header}</div>
      <div className="content-box-content">{children}</div>
    </div>
  );
};

export default ContentBox;
